import React, { createContext, Fragment, ReactElement, ReactPortal, useContext, useEffect, useState } from 'react';

import { IconButton } from 'office-ui-fabric-react';

import { WsSalesSolutionAction, WsSalesSolutionItem } from '../../core';
import { itemIsAction } from '../../helpers/item-helpers';




type WsPanelContextProps = {
  getPanelContentType: () => string;

  showAction: WsSalesSolutionItem | WsSalesSolutionAction | undefined;
  setShowAction: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | WsSalesSolutionAction | undefined>>;

  editAction: WsSalesSolutionItem | WsSalesSolutionAction | undefined;
  setEditAction: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | WsSalesSolutionAction | undefined>>;

  showDocumentsPanel: boolean;
  setShowDocumentsPanel: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialValues: WsPanelContextProps = {
  getPanelContentType: () => { console.log('getPanelContentType : not defined');; return ''; },

  showAction: undefined,
  setShowAction: () => { console.log('setShowAction : not defined'); },

  editAction: undefined,
  setEditAction: () => { console.log('setEditAction : not defined'); },

  showDocumentsPanel: false,
  setShowDocumentsPanel: () => { console.log('setShowDocumentsPanel : not defined'); },
};

const WsPanelContext = createContext<WsPanelContextProps>(initialValues);











type ReactText = string | number;
type ReactChild = ReactElement | ReactText;

interface ReactNodeArray extends Array<ReactNode> {}

type ReactFragment = {} | ReactNodeArray;
type ReactNode = ReactChild | ReactFragment | ReactPortal | boolean | null | undefined;













const panelWidth = 400;

const getContainerWidth = (windowWidth: number, detailsVisible: boolean, panelOpen: boolean) => {

  // console.log(`getContainerWidth : ${panelOpen}`);

  const detailsWidth = detailsVisible ? 250 : 30;

  if (windowWidth < 1280) {

    // if (panelOpen) {
    // } else {
    // }

    const w = panelOpen ? windowWidth - detailsWidth - panelWidth - 10 : windowWidth - detailsWidth;

    return w + 4; // not sure why additional 2 pixels need to be added?

  } else {

    const w = 1240 - detailsWidth;

    if (panelOpen) {

      const margins = windowWidth - 8 - 40 - 1240;

      const margin = margins / 2;

      const marginWithPadding = margin + 20;

      return w + marginWithPadding - panelWidth + 28 - 10; // not sure why additional 2 pixels need to be added?

    } else {
      return w + 30; // not sure why additional 2 pixels need to be added?
    }
  }
};



// ContentWithPanel

type WsSalesContainerWithPanelProps = {
  children: ReactNode;
  detailsVisible: boolean;
  panelOpen: boolean;
  panelContent: ReactNode;
  closePanel: () => void;
};

const WsSalesContainerWithPanel = (props: WsSalesContainerWithPanelProps) => {

  const panelContext = useContext(WsPanelContext);



  const [ windowSize, setWindowSize ] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });



  useEffect(() => {

    // Handler to call on window resize
    function handleResize() {
      // Set window size
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);

  }, []);



  const panelTitle = (contentType: string) => {
    if (contentType === 'documents') {
      return 'Documents';

    } else if (contentType === 'item-view' || contentType === 'item-edit') {

      const item: any = panelContext.showAction ? panelContext.showAction : (panelContext.editAction ? panelContext.editAction : undefined);

      if (item) {

        if (itemIsAction(item)) {
          return `${item.name} (Action)`;

        } else {
          return `${item.name} (Capability)`;
        }

      } else {
        return '';
      }

    } else {
      return '';
    }
  };



  // console.log(props);



  const containerWidth = getContainerWidth(windowSize.width, props.detailsVisible, props.panelOpen);

  return (
    <div className="ws-sp-container-with-panel">
      
        <div
          className="ws-sp-container"
          data-window-width={windowSize.width}
          data-width={containerWidth}
          style={{
            width: containerWidth,
            maxWidth: props.detailsVisible ? 1020 : containerWidth // TODO: refactor
          }}
        >
          {props.children}
        </div>

        {
          props.panelOpen
          &&
          <>
            <div
              className="ws-sp-panel-placeholder"
              // data-width={placeholderWidth}
              style={{
                // width: placeholderWidth
              }}
            >
              <div className="ws-sp-panel-placeholder-overlay"></div>
            </div>

            <div className="ws-sp-panel">
              <div className="ws-sp-panel-border">
                <div className="ws-sp-panel-header">
                  <div className="ws-sp-panel-header-title">{panelTitle(panelContext.getPanelContentType())}</div>
                  <IconButton
                    className="ws-sp-panel-close"
                    iconProps={{ iconName: 'ChromeClose' }}
                    onClick={() => {
                      props.closePanel();
                    }}
                  />
                </div>
                <div className="ws-sp-panel-content ws-scroll ws-scroll-y">
                  <div style={{
                    width: '100%',
                    // backgroundColor: '#e2bfff',
                    }}
                  >
                    {props.panelContent}
                    {/* {
                      process.env.NODE_ENV === 'development'
                      &&
                      <>
                        ...
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        ...
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        ...
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        ...
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        ...
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        ...
                      </>
                    } */}
                  </div>
                </div>
                <div className="ws-sp-panel-footer"></div>
              </div>
            </div>
        </>
        }
    </div>
  );
};




export {
  WsPanelContext,
  WsSalesContainerWithPanel
};
